import { useState, useEffect } from "react";
import { Link, Redirect } from "react-router-dom";

const NoMatch = () => {
  const [countdown, setCountdown] = useState(5);

  useEffect(() => {
    const timer = setInterval(() => setCountdown((prev) => prev - 1), 1000);

    return () => clearInterval(timer);
  }, []);

  if (countdown <= 0) return <Redirect to="/" />;
  return (
    <div>
      <h1>Oops!</h1>

      <p>
        We couldn't find that page. You will be redirected in {countdown}{" "}
        seconds...
      </p>
      <p>
        Or, click <Link to="/">here</Link> to go home now
      </p>
    </div>
  );
};

export default NoMatch;
